module.exports = ".section {\n  color: #949494;\n  font-size: 14px;\n  margin-left: 16px; }\n\ninput {\n  width: 216px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/autocomplete/autocomplete.component.scss
// module id = ./src/app/shared/autocomplete/autocomplete.component.scss
// module chunks = main